// Adhoc routes
export const SHOPEE_PAY_LEGACY_LOGIN_BY_PASSWORD = '/login'; // this route is for Shopee Pay legacy in TH and VN
export const SHOPEE_PAY_LEGACY_USER_PASSWORD = '/changePass'; // this route is for Shopee Pay legacy in TH and VN

// Shared routes, it could be Staff or Admin account
export const LOGIN_BY_PASSWORD = '/authenticate/login';
export const LOGIN_BY_OTP = '/authenticate/login/otp';
export const LOGIN_BY_TOKEN = '/authenticate/login/token';
export const LOGIN_BY_TOKEN_TOB_ONE_CREDENTIAL =
  '/authenticate/login/token/tob';
export const LOGIN_BY_NO_COST_AUTHENTICATION = '/authenticate/relogin';
export const RELOGIN_PAGE = '/authenticate/relogin';
export const LOGIN_BY_IVS = '/authenticate/login/ivs';
export const LOGIN_BY_THIRD_PARTY = '/authenticate/login/third-party';
export const RESET_PASSWORD = '/authenticate/reset';
export const RESET_PASSWORD_FROM_LINK = '/authenticate/reset/link';
export const SIGNUP_BY_OTP = '/authenticate/signup';
export const VERIFY_OTP = '/verify/otp';
export const VERIFY_PASSWORD = '/verify/password';
export const ACCEPT_INVITATION = '/accept/invite/:authLink';
export const IVS_SHARED_SERVICE = '/verify/ivs';
export const THIRD_PARTY_AUTHENTICATION_SERVICE =
  '/authenticate/service/third-party';
export const POST_AUTHENTICATION_SERVICE = '/post-authentication';
export const NO_COST_AUTH_ACTIVATION_SHARED_SERVICE =
  '/authenticate/service/no-cost-auth-activation';
export const LOGOUT_SHARED_SERVICE = '/authenticate/service/logout';

// User routes
export const USER = '/user';
export const USER_ACCOUNT = `${USER}/account`;
export const USER_EMAIL = `${USER}/email`;
export const USER_PASSWORD = `${USER}/password`;
export const USER_PHONE = `${USER}/phone`;
export const ACCOUNT_ONE_CREDENTIAL_MIGRATION = `${USER}/migrate`;
export const ACCOUNT_ONE_CREDENTIAL_SWITCH_TOC_LINK = `${USER}/switch-link`;
export const ACCOUNT_ONE_CREDENTIAL_DELINK = `${USER}/delink`;
export const USER_CREDENTIALS_COMMIT = `${USER}/credentials/commit`;
export const USER_ACCOUNT_LINKAGE = `${USER}/linkage`;

// Homepage
export const HOMEPAGE = '/';

/**
 * Configuration page
 * Only used in sandbox app
 */
export const CONFIG = '/__config';
